<template>
  <div>
    <div id='Main'></div>
    <div class='wei'></div>
  </div>
</template>

<script>
//  1. 先在运行依赖安装 echarts
//  2. 按需引入 echarts 图标和组件
//  3. 是写在 mounted 方法里面的
//  4. 写上 main id 的小盒子
//  5. 还要写上 main 的宽度才能看到显示

//  引入 ECharts 主模块
import echarts from 'echarts'
//  引入柱状图
//  import 'echarts/lib/chart/Main'
//  引入提示框和标题组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
export default {
  name: 'MainDemo',
  props: {
    xData: Array,
    yData: Array
  },
  data() {
    return {
      notReplyCustomerNum: [],
      replyCustomerNum: [],
      serviceActiveCustomerNum: []
    }
  },
  watch: {
    xData: function(newVal) {
      // this.initEcharts()
    },
    yData: function(newVal) {
      this.initEcharts()
    }
  },
  mounted() {
    // this.initEcharts()
  },
  methods: {
    initEcharts() {
      this.notReplyCustomerNum = []
      this.replyCustomerNum = []
      this.serviceActiveCustomerNum = []
      this.yData.forEach(k => {
        this.notReplyCustomerNum.push(k.notReplyCustomerNum)
        this.replyCustomerNum.push(k.replyCustomerNum)
        this.serviceActiveCustomerNum.push(k.serviceActiveCustomerNum)
      })

      //  基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(document.getElementById('Main'))
    //  绘制图表
    myChart.setOption({
      title: {
        text: '客户服务统计',
        subtext: '单位/人',
        left: '20px',
        top: '8px',
        textStyle: {
          color: 'rgba(0, 0, 0, 0.85)', // 颜色
          fontSize: 16, // 大小
          fontWeight: '550', // 粗细
          fontFamily: 'Source Han Sans CN'
        },
        subtextStyle: {
          color: 'rgba(0, 0, 0, 0.25)', // 颜色
          fontFamily: 'Source Han Sans CN', // 斜体
          fontWeight: '400' // 粗细
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#FFFFFF',
        borderColor: '#022F32',
        formatter: function (params) {
          var relVal = params[0].name
          for (var i = 0, l = params.length; i < l; i++) {
            relVal += '<br/>' + params[i].marker + params[i].seriesName + '：' + params[i].value
          }
          return relVal
        },
        axisPointer: {
          lineStyle: {
            width: '3',
            color: '#F0F0F0', // 显示竖线颜色
            type: 'dotted'
          }
        },
        textStyle: {
          align: 'left',
          fontSize: '12',
          color: '#000000'
        },
        extraCssText: 'box-shadow: 0px 2px 10px rgba(2, 47, 50, 0.1);padding:10px 20px;opacity: 0.9;'
      },
      legend: {
        bottom: '2%',
        data: ['回复客户次数', '未回复客户次数', '服务活跃客户数']
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '10%',
        containLabel: true
      },
      //  toolbox: {
      //    feature: {
      //      saveAsImage: {}
      //    }
      //  },
      xAxis: {
        type: 'category',
        boundaryGap: true,
        axisTick: {
          alignWithLabel: true
        },
        data: this.xData
      },
      yAxis: {
        type: 'value',
        min: 0,
        axisLine: { show: true },
        axisTick: { show: true }
      },
      series: [
        {
          name: '回复客户次数',
          type: 'line',

          smooth: true,
          itemStyle: {
            normal: {
              color: '#FF7171', // 改变折线点的颜色
              lineStyle: {
                color: '#FF7171' // 改变折线颜色
              }
            }
          },
          data: this.replyCustomerNum
        },
        {
          name: '未回复客户次数',
          type: 'line',
          smooth: true,
          itemStyle: {
            normal: {
              color: '#9FDF81', // 改变折线点的颜色
              lineStyle: {
                color: '#9FDF81' // 改变折线颜色
              }
            }
          },
          data: this.notReplyCustomerNum
        },
        {
          name: '服务活跃客户数',
          type: 'line',
          smooth: true,
          itemStyle: {
            normal: {
              color: '#9F58DB', // 改变折线点的颜色
              lineStyle: {
                color: '#9F58DB' // 改变折线颜色
              }
            }
          },
          data: this.serviceActiveCustomerNum
        }
      ]
    })
    }
  }
}
</script>
<style lang="scss" scoped>
#Main {
  width: 100%;
  height: 526px;
  padding-top: 10px;
  box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);
  border-radius: 2px 2px 2px 2px;
  background: white;
  /* border: 1px solid #000 */
}
</style>
